import React from 'react'
import { FormattedMessage } from 'react-intl'
import 'normalize.css'
import { NavHashLink as NavLink } from 'react-router-hash-link'

import Header from './Header'
import Footer from './Footer'

class Distribuidor extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <main className="main">
                <Header />
                <section className="intro distri" id="start">
                    <div className="container">
                        <div className="distri__wrapper wrapper" style={{ fontSize: '1.2rem' }}>
                            <h1 className="distri__title">
                                <strong className="distri__title__strong">
                                    <FormattedMessage id="distribuidor" defaultMessage="Distribuidor" />
                                </strong>
                            </h1>
                            <p>
                                <FormattedMessage
                                    id="dsitri_t1"
                                    defaultMessage="Hazte distribuidor y tendrás acceso a nuestro exclusivo portal de distribuidores con multitud de ventajas"
                                />
                            </p>
                            <ul style={{ maxWidth: '500px' }}>
                                <li>
                                    <FormattedMessage id="distri_li_1" defaultMessage="Precios de distribución" />
                                </li>
                                <li>
                                    <FormattedMessage id="distri_li_2" defaultMessage="Teléfono de atención técnica para distribudores" />
                                </li>
                                <li>
                                    <FormattedMessage
                                        id="distri_li_3"
                                        defaultMessage="Aplicación de gestión de proyectos internos donde compartir la información con nosotros para solicitar información y ayuda en cualquier momento"
                                    />
                                </li>
                                <li>
                                    <FormattedMessage id="distri_li_4" defaultMessage="Información sobre tus facturas, pedidos, etc..." />
                                </li>
                            </ul>
                            <p>
                                <FormattedMessage
                                    id="distri_t2"
                                    defaultMessage="Para obtener más información, por favor ponte en contacto con nosotros enviando un correo a info@openhome.io"
                                />
                            </p>
                            <a href="http://dealer.openhome.io/login" className="button" target="_blank">
                                <FormattedMessage id="acceso" defaultMessage="Acceso" />
                            </a>
                        </div>
                    </div>
                </section>

                <Footer />
            </main>
        )
    }
}

export default Distribuidor



// WEBPACK FOOTER //
// ./src/components/Distribuidor.js